function defineEasyTextsLoader(getLoader, options = {}) {
  return { getLoader, options };
}

export { defineEasyTextsLoader };
